<template>
  <div class="ml-10">
    <v-dialog v-model="dialog" width="450" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">设置</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form"
                  v-model="valid"
                  lazy-validation>
            <DatePicker
              :min='minDate'
              required
              :rules="[v => !!v || '']"
              :minTime="new Date()"
              placeholder="停机维护开始时间"
              v-model='systemShutdownStartDate'
            ></DatePicker>
            <div class="mt-4">
              <DatePicker
                required
                :rules="[v => !!v || '']"
                :min='minDate'
                :minTime="new Date()"
                placeholder="停机维护结束时间"
                v-model='systemShutdownEndDate'
              ></DatePicker>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="$refs.form.resetValidation(); dialog = false">
            取消
          </v-btn>
          <v-btn :loading="saveLoading" color="primary" @click="saveSetting">
            保存
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class='mb-0 d-flex align-center justify-end'>
      <v-switch
        v-model="shutdownSwitch"
        color="primary"
        inset
        @change="changeShutdownSwitch"
      ></v-switch>
      <span class='mr-3' style="font-size: 12px; color: #9155FD">停机维护</span>
      <v-btn text small class='ml-1' color='primary' depressed
             @click='dialog = true'
             style='transform: translateX(-10px)'>
        <v-icon size='20'>{{ icons.mdiPlus }}</v-icon>
        <span class='ml-1'>新建</span>
      </v-btn>
      <v-btn text small class='ml-1' color='primary' depressed
             @click='refresh'
             style='transform: translateX(-10px)'>
        <v-icon size='20'>{{ icons.mdiRefresh }}</v-icon>
        <span class='ml-1'>刷新</span>
      </v-btn>
    </div>

    <vxe-table
      style='z-index: 2'
      ref='dataTable'
      class='scroll-table'
      border
      resizable
      show-header-overflow
      show-overflow
      :height='tableHeight'
      :loading='tableLoading'
      size='small'
      :row-config='{isHover: true}'
      :data='settingList'
      @filter-change='search'
      :filter-config='{ remote: true }'
    >
      <vxe-column field='startDate' title='停机维护开始时间'>
      </vxe-column>
      <vxe-column field='endDate' title='停机维护结束时间'>
      </vxe-column>
      <vxe-column field='createTime' title='创建时间'
                  show-header-overflow show-overflow />
      <vxe-column field='createBy' title='创建人'
                  show-header-overflow show-overflow />
      <vxe-column title='状态' width='100' align='center'>
        <template #default='{ row }'>
          {{ row.delFlag === 0 ? '进行中' : '结束' }}
        </template>
      </vxe-column>
    </vxe-table>
    <vxe-pager
      :current-page='page.current'
      :page-size='page.size'
      :total='page.total'
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      :page-sizes='[10, 20, 50, 100]'
      @page-change='changePerPage'
    />
  </div>
</template>
<script>
import DatePicker from '@/modules/chat/components/DatePicker/index.vue'
import {
  saveSystemShutdownSetting,
  getSystemShutdownSettingPageList,
  getLookUp,
  switchSystemShutdownSetting,
} from '../api/index'

import {
  mdiRefresh,
  mdiPlus,
} from '@mdi/js'

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      valid: true,
      minDate: new Date().toISOString().substr(0, 10), // 最小日期为今天
      systemShutdownStartDate: null,
      systemShutdownEndDate: null,
      dialog: false,
      saveLoading: false,
      tableLoading: false,
      page: {
        current: 1,
        size: 10,
        total: 0,
      },
      settingList: [],
      icons: {
        mdiRefresh,
        mdiPlus,
      },
      shutdownSwitch: false,
      tableHeight: 0,
    }
  },
  mounted() {
    this.tableHeight = window.innerHeight - 64 - 50 - 50
    this.refresh()
  },
  methods: {
    async saveSetting() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.saveLoading = true
      const { data: { code, data } } = await saveSystemShutdownSetting({
        startDate: this.systemShutdownStartDate,
        endDate: this.systemShutdownEndDate,
      })
      this.saveLoading = false
      if (code === 200) {
        this.$message.success('保存成功')
      } else {
        this.$message.error('保存失败')
      }
      this.dialog = false
      await this.getSettingPageList()
    },
    async getSettingPageList() {
      this.tableLoading = true
      const { data: { code, data } } = await getSystemShutdownSettingPageList(this.page)
      this.tableLoading = false
      if (code === 200) {
        this.settingList = data.records
        this.page.total = data.total
      }
    },
    search() {
    },
    changePerPage(currentPage) {
      this.page.current = currentPage.currentPage
      this.page.size = currentPage.pageSize
      this.getSettingPageList()
    },
    refresh() {
      this.page.current = 1
      this.page.size = 10
      this.getSettingPageList()

      let formData = new FormData()
      formData.append('classifyCode', 'CHATBOT_SYSTEM_SHUTDOWN')
      getLookUp(formData).then(res => {
        if (res.data.code === 200) {
          let lookUps = res.data.data || []
          this.shutdownSwitch = lookUps[0].value === 'YES'
        }
      })
    },
    changeShutdownSwitch() {
      switchSystemShutdownSetting({ value: this.shutdownSwitch ? 'YES' : 'NO' }).then(res => {
        if (this.shutdownSwitch) {
          this.$message.success('开启停机维护成功')
        } else {
          this.$message.success('关闭停机维护成功')
        }
        this.getSettingPageList()
      })
    },
  },
}
</script>
